import {
  IPricePoliciesEntity,
  IPricePoliciesListResponse,
} from '../Services/api/price-policies/price-policies.interface';
import { ListPricePoliciesUseCase } from '../Usecase/PricePolicies/list-price-policies-usecase';

const MAX_PAGES = 50;

export function normalizePricePoliciesListResponse(
  raw?: Partial<IPricePoliciesListResponse> | null
): IPricePoliciesListResponse {
  if (Array.isArray(raw)) {
    return {
      data: raw,
      total: raw.length,
      hasNext: false,
      hasNextPage: false,
    };
  }

  const sourceData = raw?.data;
  const data = Array.isArray(sourceData) ? sourceData : [];
  const total = Number(raw?.total ?? data.length) || data.length;
  const hasNextPage = Boolean(raw?.hasNextPage ?? raw?.hasNext);
  const hasNext = Boolean(raw?.hasNext ?? raw?.hasNextPage);

  return {
    data,
    total,
    hasNext,
    hasNextPage,
  };
}

const MODAL_PAGE_SIZE = 200;

export async function fetchAllPricePolicies(
  listPricePoliciesUseCase: ListPricePoliciesUseCase,
  searchBy?: string
): Promise<IPricePoliciesEntity[]> {
  const pageSize = MODAL_PAGE_SIZE;
  const uniqueById = new Map<string, IPricePoliciesEntity>();
  let page = 1;

  while (page <= MAX_PAGES) {
    const listResult = await listPricePoliciesUseCase.handle({
      page,
      searchBy,
      offset: pageSize,
    });

    if (listResult.isFailure) {
      throw new Error(String(listResult.error?.error ?? 'Erro ao listar políticas de preço'));
    }

    const response = normalizePricePoliciesListResponse(listResult.getValue());

    if (!response.data.length) {
      break;
    }

    let added = 0;
    response.data.forEach((policy) => {
      if (policy?.id && !uniqueById.has(policy.id)) {
        uniqueById.set(policy.id, policy);
        added += 1;
      }
    });

    if (added === 0) {
      break;
    }

    page += 1;
  }

  return Array.from(uniqueById.values());
}
